module.exports = __webpack_public_path__ + "img/spring_collection_bg.d6753326.jpg";